import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { SET_SPOUSAL_INFO_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class SpousalInfoRequest extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = {};

  url = SET_SPOUSAL_INFO_URL;

  constructor(requestBody, paramList) {
    super();
    this.body = requestBody;
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
